const zh = {
  // Navbar
  nav_home: "首页",
  nav_about: "关于点点大叔",
  nav_services: "服务与价格",
  nav_flow: "服务流程",
  nav_testimonials: "用户评价",
  nav_faq: "常见问题",
  nav_contact: "联系我们",
  nav_cta: "预约姓名鉴定",
  nav_subtitle: "姓名鉴定 · 冲绳",
  nav_title: "点点大叔鉴定所",

  // Hero
  hero_headline1: "在宁静的",
  hero_headline2: "冲绳岛屿",
  hero_headline3: "聆听你",
  hero_headline4: "名字的声音。",
  hero_body: "预约排队数月的热门姓名鉴定。\n每个月我亲自前往冲绳的岛屿，\n将您的名字传达给大师。",
  hero_pill1: "无需改名",
  hero_pill2: "100% 线上",
  hero_pill3: "一个月内交付",
  hero_pill4: "每月前100名",
  hero_btn_apply: "预约姓名鉴定",
  hero_btn_services: "查看服务",
  hero_scroll: "向下滚动",

  // About
  about_heading: "关于点点大叔",
  about_intro: "在被冲绳温柔海洋环绕的宁静小岛<strong>伊计岛</strong>上，\n住着一位默默为每个名字添加一点光芒的人。\n人们亲切地称他为<strong>「点点大叔」</strong>。",
  about_block1_label: "从银行家到姓名鉴定师",
  about_block1_text: "点点大叔最初是一名银行家。\n凭借勤奋努力，他成为公司<strong>最年轻的支行行长</strong>。\n在与众多人打交道的过程中，他心中产生了一个疑问。",
  about_block1_quote: "「为什么同样努力工作，有些人却仿佛乘风而行？」",
  about_block1_sub: "这个小小的疑问，成为了一段伟大探索之旅的起点。",
  about_block2_label: "古老智慧与宁静的启示",
  about_block2_text: "他将每一分空闲时间都用于研究古代姓名鉴定典籍，仔细探究传统汉字的笔画数量和音韵流动。",
  about_block2_text2: "他领悟到<strong>「浊点（てんてん）能够悄悄调和名字的流动」</strong>。",
  about_block2_sub: "这不是戏剧性的魔法，也不是华而不实的成功公式，\n而是一条温柔的道路，让人内心已有的光芒更加清晰可见。",
  about_block3_label: "口耳相传——如今需等待6个月",
  about_block3_text: "他温柔的鉴定完全通过口耳相传传播，如今<strong>来自全日本的咨询络绎不绝</strong>。\n无论对方是否有名气，他都以同样的关怀对待每一个人。\n他将手放在每个名字上，陪伴那个人的人生。\n这就是点点大叔的风格。",

  // Gallery
  gallery_heading: "图片展示",
  gallery_sub: "冲绳 · 伊计岛",

  // Services
  services_heading: "服务与价格",
  services_note1: "※ 所有套餐均包含大师鉴定费及我们的现场代理服务费。",
  services_note2: "※ 无任何额外费用。请放心委托。",
  services_tab1: "个人姓名",
  services_tab2: "商号名称",
  services_tab3: "宠物名字",
  services_tab1_en: "Personal Name",
  services_tab2_en: "Business Name",
  services_tab3_en: "Pet Name",
  services_tab1_desc: "我们温柔地观察您的成长、环境和内心动向，为您添加最适合的浊点。",
  services_tab2_desc: "为新的挑战带来温柔的顺风。悄悄调和您事业的流动。",
  services_tab3_desc: "为始终陪伴在您身边的家庭成员。赋予充满安宁与温暖的名字。",
  services_row1_target1: "16岁及以上",
  services_row1_target2: "4至15岁",
  services_row1_target3: "0至3岁",
  services_row2_target1: "商号 / 公司 / 店铺名称",
  services_row3_target1: "宠物名字",
  services_col_target: "适用对象",
  services_col_price: "价格（含税）",
  services_cta: "预约此服务",
  services_includes_title: "包含内容（全部含在价格内）",
  services_inc1: "姓名鉴定",
  services_inc2: "最佳浊点建议",
  services_inc3: "名片尺寸卡片邮寄（免费，按需）",
  services_inc4: "开运建议",
  services_inc5: "姓名卡片数码照片",
  services_includes_note: "鉴定旨在温柔地彰显您名字中已有的魅力。",
  services_payment_title: "付款方式",
  services_payment_method: "银行转账（预付款）",
  services_payment_desc: "申请后我们将提供银行账户信息。\n付款完成后，好运的流动将悄然开始汇聚。",
  services_first_title: "初次来访的朋友",
  services_first_desc: "感到不安是很自然的。\n这种感觉是您内心的信号，\n提示您是时候开始温柔的改变了。",
  services_first_cta: "从咨询开始",

  // Flow
  flow_heading: "服务流程",
  flow_step1_title: "提交申请表",
  flow_step1_c1: "请在专用表格中填写必要信息。",
  flow_step1_c2: "提交后，我们将在2至3个工作日内回复您。",
  flow_step1_c3: "邮件中将说明后续步骤及银行转账说明。",
  flow_step2_title: "转账支付鉴定费",
  flow_step2_c1: "请将鉴定费转账至回复邮件中指定的账户。",
  flow_step2_c2: "确认收款后，我们将按顺序开始准备您的鉴定。",
  flow_step3_title: "通知我们转账完成",
  flow_step3_c1: "转账后，请将收据照片发送至邮件中指定的地址。",
  flow_step3_c2: "确认后，我们将向您发送「登记完成」的消息。",
  flow_step3_note: "若未收到此通知，我们可能无法开始您的鉴定。请务必发送。",
  flow_step4_title: "接收鉴定结果",
  flow_step4_c1: "鉴定完成后约一周，我们将通过电子邮件发送姓名卡片及浊点的照片。",
  flow_step4_c2: "随后，我们将通过电子邮件发送详细的鉴定报告和开运建议。",
  flow_step5_title: "寄送姓名卡片（可选）",
  flow_step5_c1: "应要求，我们将邮寄大师手写的名片尺寸卡片。",
  flow_step5_c2: "请在申请表的地址栏中填写准确的邮寄地址。",
  flow_step5_note: "如不需要卡片，填写您所在城市即可。",
  flow_banner_title: "全程线上。来自日本任何地方。",
  flow_banner_desc: "无需前往冲绳伊计岛。\n您可以在不改变日常生活的情况下立即开始。",
  flow_banner_cta: "立即申请",

  // Testimonials
  testimonials_heading: "用户评价",
  testimonials_viewing: "正在查看",

  // FAQ
  faq_heading: "常见问题",
  faq_cta_title: "还有其他问题？",
  faq_cta_desc: "欢迎提出任何小问题。\n那些您不好意思开口的问题——正是我们最想听到的。",
  faq_cta_btn: "向我们提问",

  // CTA Banner
  cta_heading1: "免费",
  cta_heading2: "咨询",
  cta_btn: "立即预约",

  // Contact
  contact_heading: "联系我们",
  contact_desc: "请通过此表格提交鉴定申请或咨询。我们通常在2至3个工作日内回复。",
  contact_address_label: "地址",
  contact_address_value: "日本栃木县（线上 · 全国对应）",
  contact_email_label: "电子邮件",
  contact_hours_label: "营业时间",
  contact_hours_value: "周一至周五 9:00–18:00（周六/周日/节假日休息）",
  contact_note_title: "关于回复",
  contact_note_desc: "我们的回复可能会进入垃圾邮件文件夹。\n如果您在2至3个工作日内未收到回复，请直接通过电子邮件联系我们。",
  contact_field_name: "姓名",
  contact_field_furigana: "假名（读音）",
  contact_field_email: "电子邮件地址",
  contact_field_phone: "电话号码",
  contact_field_service: "希望的服务",
  contact_field_message: "留言",
  contact_placeholder_name: "张三",
  contact_placeholder_furigana: "ヤマダ タロウ",
  contact_placeholder_email: "example@mail.com",
  contact_placeholder_phone: "+86 000 0000 0000",
  contact_placeholder_message: "请输入您希望鉴定的姓名，或您的问题和需求。",
  contact_select_placeholder: "请选择",
  contact_service1: "个人姓名",
  contact_service2: "商号名称",
  contact_service3: "宠物名字",
  contact_service4: "其他 / 咨询",
  contact_submit: "提交",
  contact_submitting: "提交中...",
  contact_privacy: "通过表格提交的个人信息将仅用于姓名鉴定服务。",
  contact_error: "提交失败。请稍后再试，或直接通过电子邮件联系我们。",
  contact_err_name: "请输入您的姓名",
  contact_err_email_required: "请输入电子邮件地址",
  contact_err_email_invalid: "请输入有效的电子邮件地址",
  contact_err_service: "请选择服务",
  contact_err_message_required: "请输入留言内容",
  contact_err_message_limit: "留言请限制在500字以内",
  contact_thanks_title: "消息已发送",
  contact_thanks_desc: "感谢您的联系。\n我们将审阅您的消息，并在<strong>2至3个工作日</strong>内回复您。\n请稍候。",
  contact_thanks_check1: "请查收确认邮件",
  contact_thanks_check2: "请同时检查垃圾邮件文件夹",
  contact_thanks_check3: "请等待2至3个工作日的回复",
  contact_thanks_another: "再次发送消息",

  // Footer
  footer_subtitle: "姓名鉴定 · 冲绳",
  footer_title: "点点大叔鉴定所",
  footer_desc: "从冲绳到全日本。拥有50年以上经验的姓名鉴定大师，用心解读您名字中的命运。",
  footer_contact_title: "联系信息",
  footer_address_label: "地址",
  footer_address_value: "日本栃木县\n（线上 · 全国对应）",
  footer_email_label: "邮件",
  footer_hours_label: "营业时间",
  footer_hours_value: "周一至周五 9:00–18:00\n（周六/周日/节假日休息）",
  footer_nav_title: "导航",
  footer_copyright: "© 2025 点点大叔鉴定所 版权所有。",
  footer_privacy: "隐私政策",
  footer_law: "特定商取引法",
  footer_sitemap: "网站地图",
};

export default zh;
